@if (orderHistoryDatasource) {
  <app-page [headline]="'Orders'">
    <DataTable
      [datasource]="orderHistoryDatasource"
      [columns]="orderHistoryColumns"
      (rowClick)="handleRowClick($event)"
    >
      <div ngProjectAs="data-table-header" stack-layout gap="md">
        <div
          grid-layout
          gap="md"
          [fullWidth]="true"
          templateColumns="repeat(auto-fit, minmax(310px, 1fr))"
        >
          <div>
            <div row-layout gap="sm">
              <div box-layout [grow]="1">
                <div box-layout paddingLeft="sm">
                  <Text role="headline-small">Start Date</Text>
                </div>

                <app-input
                  [form]="searchForm"
                  controlName="startDate"
                  type="date"
                  [max]="getTodaysDate()"
                />
              </div>

              <div box-layout [grow]="1">
                <div box-layout paddingLeft="sm">
                  <Text role="headline-small">End Date</Text>
                </div>
                <app-input
                  [form]="searchForm"
                  controlName="endDate"
                  type="date"
                  [min]="endDateMinValue()"
                  [max]="getTodaysDate()"
                />
              </div>
            </div>
          </div>

          <div>
            <div box-layout paddingLeft="sm">
              <Text role="headline-small">Order Number</Text>
            </div>
            <app-input [form]="searchForm" controlName="orderNumber" />
          </div>

          <div>
            <div box-layout paddingLeft="sm">
              <Text role="headline-small">WMS Order Number</Text>
            </div>
            <app-input [form]="searchForm" controlName="erpOrderNumber" />
          </div>

          <div stack-layout [fullWidth]="true">
            <div box-layout paddingLeft="sm">
              <Text role="headline-small">DCC</Text>
            </div>

            <form [formGroup]="searchForm">
              <app-multi-select-dropdown
                [options]="dccOptions()"
                [enableAll]="true"
                formControlName="dcc"
              ></app-multi-select-dropdown>
            </form>
          </div>

          <div stack-layout [fullWidth]="true">
            <div box-layout paddingLeft="sm">
              <Text role="headline-small">Warehouse</Text>
            </div>

            <form [formGroup]="searchForm">
              <app-multi-select-dropdown
                [options]="warehouseOptions()"
                [enableAll]="true"
                formControlName="warehouse"
              ></app-multi-select-dropdown>
            </form>
          </div>

          <div>
            <div box-layout paddingLeft="sm">
              <Text role="headline-small">Company Name</Text>
            </div>
            <app-input [form]="searchForm" controlName="buyerCompanyName" />
          </div>

          <div stack-layout [fullWidth]="true">
            <div box-layout paddingLeft="sm">
              <Text role="headline-small">Warehouse System</Text>
            </div>

            <form [formGroup]="searchForm">
              <app-multi-select-dropdown
                [options]="wmsOptions()"
                [enableAll]="true"
                formControlName="wms"
              ></app-multi-select-dropdown>
            </form>
          </div>

          <div stack-layout [fullWidth]="true">
            <div box-layout paddingLeft="sm">
              <Text role="headline-small">Status</Text>
            </div>

            <form [formGroup]="searchForm">
              <app-multi-select-dropdown
                [options]="statusOptions"
                [enableAll]="true"
                formControlName="status"
              ></app-multi-select-dropdown>
            </form>
          </div>
        </div>

        <div grid-layout [fullWidth]="true">
          <div row-layout justifyContent="end" gap="md">
            <button
              text-button
              variant="primary"
              size="md"
              (click)="searchOrders()"
              [loading]="orderHistoryDatasource.isLoading()"
            >
              Search
            </button>
            <button
              text-button
              variant="ghost"
              size="md"
              (click)="resetSearchForm(activeRegionId())"
              [loading]="orderHistoryDatasource.isLoading()"
            >
              Reset search
            </button>
          </div>
        </div>

        <oui-divider border="medium" />

        <div stack-layout gap="xs" paddingBottom="sm">
          <div box-layout paddingLeft="sm">
            <Text role="headline-small">Order Status</Text>
          </div>
          <div class="order-status-tiles-grid">
            @for (tile of statusTiles; track tile.key) {
              <div
                role="button"
                [attr.tabindex]="isStatusTileDisabled(tile.key) ? -1 : 0"
                class="order-status-tile"
                [attr.data-status]="tile.key"
                [attr.aria-disabled]="isStatusTileDisabled(tile.key)"
                [class.order-status-tile--active]="activeStatusTile() === tile.key"
                [class.order-status-tile--disabled]="isStatusTileDisabled(tile.key)"
                (click)="!isStatusTileDisabled(tile.key) && applyStatusTileFilter(tile.key)"
                (keydown.enter)="!isStatusTileDisabled(tile.key) && applyStatusTileFilter(tile.key)"
                (keydown.space)="!isStatusTileDisabled(tile.key) && applyStatusTileFilter(tile.key)"
              >
                <span class="order-status-tile__icon" aria-hidden="true">
                  <Symbol
                    [name]="getStatusTileIcon(tile.key)"
                    class="order-status-tile__icon-symbol"
                  />
                </span>
                <span class="order-status-tile__content">
                  <span class="order-status-tile__label">{{ tile.label }}</span>
                  <span class="order-status-tile__count">
                    {{ getStatusTileCount(tile.key) }}
                  </span>
                </span>
              </div>
            }
          </div>
        </div>

        <div row-layout justifyContent="end" [fullWidth]="true">
          <div row-layout justifyContent="end" gap="md">
            <app-download-button
              mode="text"
              [blobObservable]="
                orders.downloadOrders(orderHistoryDatasource.getPageRequest())
              "
              label="Export Orders"
              [downloadFileName]="ordersDownloadFilename"
              (click)="refreshOrdersDownloadFilename()"
            />
          </div>
        </div>
      </div>
      <div ngProjectAs="data-table-footer" stack-layout gap="md">
        <div grid-layout>
          <div row-layout justifyContent="space-between">
            <Text>
              {{ orderHistoryDatasource.recordCount() }} Orders Found</Text
            >
            <Paginator
              [datasource]="orderHistoryDatasource"
              [initPageSize]="10"
            />
            <div></div>
          </div>
        </div>
      </div>
    </DataTable>
  </app-page>
}

<ng-template #noResults>
  <div center-layout padding="md">
    <Text role="headline-medium">No Results Found</Text>
  </div>
</ng-template>

<ng-template #orderDateCell let-orderDate="orderDate">
  <div box-layout paddingHorizontal="sm" paddingVertical="sm">
    <Text display="block" [nowrap]="true">
      {{ getDateTime(orderDate) }}
    </Text>
  </div>
</ng-template>

<ng-template #orderStatusCell let-status="status">
  <div box-layout paddingHorizontal="sm" paddingVertical="sm">
    <div
      oui-badge
      color="quaternary"
      [style.background-color]="getStatusColor(status)"
    >
      {{ getStatusLabel(status) }}
    </div>
  </div>
</ng-template>